module.exports = __webpack_public_path__ + "img/1468805026.3cd8b189.jpg";